import React from "react";
import { useState } from "react";
import logo from "../images/logo.png";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { CiTwitter } from "react-icons/ci";
import { FaTelegramPlane } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const [toggle, setToggle] = useState();
  const navigate = useNavigate();

  const changeToggle = (index) => {
    setToggle(index);
  };

  const openGooglePlay = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.trinet_wallet",
      "_blank"
    );
  };

  const openAppleStore = () => {
    window.open(
      "https://apps.apple.com/in/app/whatsapp-messenger/id310633997",
      "_blank"
    );
  };


  return (
    <div className="max-w-[1200px] flex md:flex-row flex-col-reverse mx-auto border border-gray-300  rounded-3xl bg-gray-200 p-10 lg:mb-10">
      <div className="flex items-center justify-center flex-col md:w-1/3 w-full bg-gray ">
        <div className="flex flex-col items-center justify-center w-full mt-10">
          <h2 className="font-bold  md:text-4xl text-3xl text-[#fcc204] w-full text-center">
            Trinet Wallet
          </h2>
          <div className="h-[250px] w-[250px] overflow-hidden -mt-10 ">
            <img
              className="h-[300px] w-[300px] object-cover"
              src={logo}
              alt="Logo"
            />
          </div>
        </div>
      </div>
      <div className="md:grid grid-cols-2 grid-cols-1   md:w-2/3 w-full flex flex-col-reverse justify-center items-center bg-gray  ">
        {/* Row  */}
        <div className="grid md:grid-cols-4 grid-cols-2 md:col-span-2 col-span-1 w-full justify-center items-start">
          <div className="flex-1 ">
            <h3 className="font-bold text-sm text-black-400 my-6">Wallet</h3>
            <p className="text-sm my-2">Mobile App</p>
            <p className="text-sm my-2">Browser Extension</p>
          </div>

          <div className="flex-1 ">
            <h3 className="font-bold text-sm text-black-400 my-6">Features</h3>
            <p className="text-sm my-2">Buy Crypto</p>
            <p className="text-sm my-2">Sell Crypto</p>
            <p className="text-sm my-2">Swaps</p>
            <p className="text-sm my-2">Staking</p>
            
            <p className="text-sm my-2">Security</p>
          </div>

          <div className="flex-1 ">
            <h3 className="font-bold text-sm text-black-400 my-6">Support</h3>
            <p className="text-sm my-2">FAQ</p>
            <p className="text-sm my-2">Contact Us</p>
          </div>

          <div className="flex-1 ">
            <h3 className="font-bold text-sm text-black-400 my-6">About</h3>
            <p className="text-sm my-2">About Us</p>
            <p className="text-sm my-2">Careers</p>
            <p className="text-sm my-2">Press Kits</p>
            <p className="text-sm my-2">Terms of Services</p>
            <p
              className="text-sm my-2 cursor-pointer"
              onClick={() => {
                navigate("/privacy");
              }}
            >
              Privacy Policy
            </p>
          </div>
        </div>
        <div className="w-full flex md:flex-col  justify-beetween sm:flex-row flex-col my-10  gap-5">
          <div className="flex flex-col">
            <h4>Download Trinet Wallet</h4>
            <p className="text-sm my-2">
              The most trusted & secure crypto wallet.
            </p>
          </div>
          <div className="w-[210px]">
            {/* <div className="flex max-w-[600px] w-full  flex-wrap gap-3 desktop:max-w-none"> */}
            <div className="flex max-w-[600px] w-full flex-wrap gap-3 desktop:max-w-none">
              <a
                className="flex-grow px-5 py-2.5 h-9 relative z-10 overflow-hidden flex items-center justify-center gap-3 rounded-full text-center font-medium bg-transparent border border-blue-700 !text-[13px] bluehover"
                onMouseOver={() => changeToggle(1)}
                onMouseOut={() => changeToggle(0)}
                onClick={openAppleStore}
              >
                Download for iOS
                <svg
                  width="17"
                  height="20"
                  viewBox="0 0 17 20"
                  fill="none"
                  className="h-[18px] w-auto"
                >
                  <path
                    d="M13.6264 10.8929C13.6048 8.48359 15.5992 7.31145 15.6904 7.25688C14.5609 5.61004 12.8101 5.38504 12.1949 5.36709C10.7245 5.21235 9.29817 6.24695 8.54914 6.24695C7.78515 6.24695 6.63169 5.38204 5.38853 5.40746C3.7888 5.43213 2.29222 6.35833 1.47142 7.7966C-0.22251 10.7292 1.04083 15.0388 2.66375 17.4092C3.47558 18.5702 4.42421 19.8664 5.66587 19.8208C6.88063 19.7707 7.33438 19.0464 8.80031 19.0464C10.2528 19.0464 10.6789 19.8208 11.9452 19.7916C13.2489 19.7707 14.0697 18.6255 14.8532 17.4541C15.7913 16.1235 16.1681 14.813 16.183 14.7457C16.1524 14.7353 13.6511 13.7807 13.6264 10.8929Z"
                    style={{ fill: `${toggle === 1 ? "white" : "blue"} ` }}
                  ></path>
                  <path
                    d="M11.2914 3.51592C11.9447 2.69886 12.3918 1.58727 12.2677 0.459229C11.322 0.501091 10.1394 1.11333 9.4584 1.91245C8.85588 2.61663 8.31765 3.77084 8.45669 4.85627C9.51895 4.93551 10.6096 4.32028 11.2914 3.51592Z"
                    style={{ fill: `${toggle === 1 ? "white" : "blue"} ` }}
                  ></path>
                </svg>
              </a>

              <a
                className="flex-grow px-5 py-2.5 h-9 relative z-10 overflow-hidden flex items-center justify-center gap-3 rounded-full text-center font-medium bg-transparent border border-blue-700 !text-[13px] bluehover"
                onMouseOver={() => changeToggle(2)}
                onMouseOut={() => changeToggle(0)}
                onClick={openGooglePlay}
              >
                Download for Android
                <svg
                  width="20"
                  height="23"
                  viewBox="0 0 20 23"
                  fill="none"
                  className="h-[18px] w-auto"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.1661 2.03226L12.9174 2.39815C14.8051 3.25494 16.083 4.87765 16.083 6.73464H3.62062C3.62062 4.87765 4.89853 3.25494 6.7876 2.39815L6.53741 2.03226L6.28858 1.67167L5.73418 0.860934C5.6666 0.760914 5.69497 0.626695 5.79642 0.560918C5.89917 0.495053 6.03709 0.521407 6.10605 0.621428L6.70103 1.49008L6.95122 1.85457L7.20409 2.22572C8.00869 1.92171 8.90658 1.75195 9.85177 1.75195C10.7984 1.75195 11.6949 1.92171 12.4995 2.22572L12.7537 1.85457L13.6002 0.621428C13.6665 0.521407 13.8058 0.493753 13.9072 0.560918C14.0099 0.626695 14.0384 0.760914 13.9694 0.860934L13.4149 1.67167L13.1661 2.03226ZM3.62062 7.60078H3.71665H16.083V17.132C16.083 17.8887 15.4528 18.5046 14.6739 18.5046H13.6557C13.6908 18.6191 13.7111 18.7389 13.7111 18.8652V21.6093C13.7111 22.3266 13.112 22.9083 12.3737 22.9083C11.6368 22.9083 11.0391 22.3266 11.0391 21.6093V18.8652C11.0391 18.7389 11.058 18.6191 11.0918 18.5046H8.61176C8.64555 18.6191 8.66584 18.7389 8.66584 18.8652V21.6093C8.66584 22.3266 8.06682 22.9083 7.32988 22.9083C6.59286 22.9083 5.99384 22.3266 5.99384 21.6093V18.8652C5.99384 18.7389 6.01275 18.6191 6.04792 18.5046H5.03103C4.25214 18.5046 3.62062 17.8887 3.62062 17.132V7.60078ZM1.39463 7.60078C0.65632 7.60078 0.0585938 8.18254 0.0585938 8.89976V14.4603C0.0585938 15.1776 0.65632 15.7593 1.39463 15.7593C2.13157 15.7593 2.7293 15.1776 2.7293 14.4603V8.89976C2.7293 8.18254 2.13157 7.60078 1.39463 7.60078ZM16.9739 8.89976C16.9739 8.18254 17.5716 7.60078 18.31 7.60078C19.0469 7.60078 19.6446 8.18254 19.6446 8.89976V14.4603C19.6446 15.1776 19.0469 15.7593 18.31 15.7593C17.5716 15.7593 16.9739 15.1776 16.9739 14.4603V8.89976ZM6.09745 5.00125C5.72833 5.00125 5.42961 4.71049 5.42961 4.35126C5.42961 3.99203 5.72833 3.70262 6.09745 3.70262C6.4665 3.70262 6.76529 3.99203 6.76529 4.35126C6.76529 4.71049 6.4665 5.00125 6.09745 5.00125ZM10.7712 4.35126C10.7712 4.71049 11.07 5.00125 11.4391 5.00125C11.8081 5.00125 12.1069 4.71049 12.1069 4.35126C12.1069 3.99203 11.8081 3.70262 11.4391 3.70262C11.07 3.70262 10.7712 3.99203 10.7712 4.35126Z"
                    style={{ fill: `${toggle === 2 ? "white" : "blue"} ` }}
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>

        
        <div className="mb-0">
          <h3 className="text-xl font-semibold my-4">Stay Connected:</h3>
          <div className="flex flex-row justify-start items-center">
            <button className="bg-black text-white rounded-xl p-2 hover:text-black  hover:bg-white shadow shadow-2xl duration-300 mx-2"
            onClick={()=>{
              window.open(
                "https://www.facebook.com/Trientwalletoffical",
                "_blank"
              )
              
            }}
            >
              <FaFacebookF className="text-xl font-bold " />
            </button>
            <button 
            onClick={()=>{
              window.open(
                "https://www.instagram.com/trinetwalletoffical/",
                "_blank"
              )
            }}
            className="bg-black text-white rounded-xl p-2 hover:text-black  hover:bg-white shadow shadow-2xl duration-300 mx-2">
              <FaInstagram className="text-xl font-bold " />
            </button>
            <button className="bg-black text-white rounded-xl p-2 hover:text-black  hover:bg-white shadow shadow-2xl duration-300 mx-2"
            onClick={()=>{
              window.open(
                "https://twitter.com/trinetwallet",
                "_blank"
              )
              
            }}
            
            
            >
              <CiTwitter className="text-xl font-bold " />
            </button>
            <button className="bg-black text-white rounded-xl p-2 hover:text-black  hover:bg-white shadow shadow-2xl duration-300 mx-2"
            
            onClick={()=>{
              window.open(
                "https://t.me/trinetwallet",
                "_blank"
              )
              
            }}
            >
              <FaTelegramPlane className="text-xl font-bold " />
            </button>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
